/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */

import { PaymentCardBrandType, PaymentIntentStatus } from "./PaymentIntent.interface";
import { ICurrency } from "./SubscriptionPlans";

export const userInterfaceKeys = ["email", "password", "first_name", "last_name", "company", "timezone", "language"];
export interface IUserRegistrationData extends Record<typeof userInterfaceKeys[number], string> { }

type UserInformationType = Omit<IUserRegistrationData, "password">;

export interface IUserInformation extends UserInformationType {
  uuid: string;
  currency: ICurrency;
}

export interface IUserLoginData {
  email: string;
  password: string;
}
export interface IUserResetPassword {
  token: string;
  data: {
    password: string;
  };
}

export interface ITokens {
  access: string;
  refresh: string;
}

export interface IUserSubscription {
  id: string;
  amount: number;
  currency: ICurrency;
  billing_interval: string;
  billing_date: string;
  creation_date: string;
  project_uuid: string;
}

export interface IUserInvoice {
  id: string;
  amount: number;
  currency: ICurrency;
  creation_date: string;
  invoice_pdf: string;
  subscription_plan: string;
  project_uuid: string;
}

export interface IUserPayment {
  id: string;
  amount: number;
  currency: ICurrency;
  creation_date: string;
  card_brand: PaymentCardBrandType;
  card_last_4: string;
  description: string;
  status: PaymentIntentStatus;
  invoice: string;
}

export interface IUserPaymentMethods {
  id: string,
  creation_date: string,
  card_brand: PaymentCardBrandType,
  card_last_4: string,
  exp_year: number,
  exp_month: number
}